export const firebaseConfig = {
  apiKey: "AIzaSyDO9oJVtGG_nPcKmic91teP3Dc73EHu0cw",
  authDomain: "webpage-5a874.firebaseapp.com",
  projectId: "webpage-5a874",
  storageBucket: "webpage-5a874.firebasestorage.app",
  messagingSenderId: "993447980166",
  appId: "1:993447980166:web:b4b3e6e2ca17461fea7507",
};